import * as constants from './constants';
import { get, post, put, del } from '../../utils/http';
import checkStatus from '../../utils/checkStatus';
import R from 'ramda';
import querystring from 'query-string';

const isNilOrEmpty = R.either(R.isNil, R.isEmpty);

export function updateProps(payload) {
  return { type: constants.UPDATE_PROPS, payload };
}

// export const getNotifications = () => (dispatch, getState) => {
//   return get(`/proxy/notifications`)
//   .then(checkStatus)
//   .then(res => res.json())
//   .then(res => dispatch({ type: constants.GOT_NOTIFICATIONS, payload: res }));
// };

export const markAsRead = (activityIds) => (dispatch, getState) => {
  dispatch({ type: constants.MARKED_READ, payload: { activityIds } });
  return put('/proxy/notifications', { activityIds })
  .then(checkStatus);
};



// WEBPACK FOOTER //
// ./src/app/stores/notification/actions.js